/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */

export type FeatureFlagNameEnum = typeof FeatureFlagNameEnum[keyof typeof FeatureFlagNameEnum];


export const FeatureFlagNameEnum = {
  AI_CALL_OVERLAY: 'ai_call_overlay',
  AI_CHAT_IMAGE_EDITING: 'ai_chat_image_editing',
  AI_CHAT_EDIT_MATERIAL: 'ai_chat_edit_material',
  AI_CHAT_TOOL_DISCOVERY: 'ai_chat_tool_discovery',
  AI_CHAT_RUN_ACTIVITY: 'ai_chat_run_activity',
  AI_CHAT_SKILLS: 'ai_chat_skills',
  AI_SKILL_BUNDLES: 'ai_skill_bundles',
  AI_FORM_COMPLETION_IMAGE: 'ai_form_completion_image',
  AI_GOOGLE_DRIVE: 'ai_google_drive',
  AGENT_TOOL_CONFIRMATION: 'agent_tool_confirmation',
  AI_PREVIEW_IMAGE: 'ai_preview_image',
  AI_TEXT_EXTRACT: 'ai_text_extract',
  APPLE: 'apple',
  ASSISTANT_HANDOFF: 'assistant_handoff',
  AUSTRIA: 'austria',
  BILDUNG_LSA: 'bildung_lsa',
  COLLECTION_COURSES: 'collection_courses',
  DEEP_RESEARCH: 'deep_research',
  EDULOG: 'edulog',
  EDUPOOL: 'edupool',
  ELEVENLABS: 'elevenlabs',
  FOOTER: 'footer',
  FLYOUT_AI_LITERACY_TRAINING: 'flyout_ai_literacy_training',
  GALLERY_PREVIEW_IMAGE: 'gallery_preview_image',
  GO_APP_HANDOFF: 'go_app_handoff',
  GOOGLE_OAUTH2: 'google_oauth2',
  H5P_STATIC_MANIFEST: 'h5p_static_manifest',
  HIDE_GENERATED_EMAILS_IN_PUBLIC_API: 'hide_generated_emails_in_public_api',
  HIDE_GENERATED_EMAILS_IN_PUBLIC_API_FOR_FELLOWFISH: 'hide_generated_emails_in_public_api_for_fellowfish',
  HUBSPOT_CRM_SOURCE: 'hubspot_crm_source',
  LUX: 'lux',
  MICROSOFT_OFFICE365: 'microsoft_office365',
  QWEN_FILE_EMBEDDINGS: 'qwen_file_embeddings',
  SEARCH_CURRICULUM: 'search_curriculum',
  CURRICULUM_REFERENCES: 'curriculum_references',
  CURRICULUM_LIBRARY: 'curriculum_library',
  SHARED_LIBRARY_PAGE: 'shared_library_page',
  SHARED_LIBRARY_PUBLISH: 'shared_library_publish',
  SHARED_LIBRARY_TRASH: 'shared_library_trash',
  SHARED_LIBRARY_SEARCH: 'shared_library_search',
  SHARED_LIBRARY_TOOL_INDEX: 'shared_library_tool_index',
  SHOW_SERVER_STATUS_BANNER: 'show_server_status_banner',
  TO_TEACH_PROJECT_IMPORT: 'to_teach_project_import',
  TIMETABLE_LESSON_PLAN: 'timetable_lesson_plan',
  TRASH_RETENTION_ENFORCEMENT: 'trash_retention_enforcement',
  UNIFIED_SELECT_DROPDOWNS: 'unified_select_dropdowns',
  UNTIS: 'untis',
  UNTIS_PRODUCTION: 'untis_production',
  USER_EXPORT: 'user_export',
  VIDIS: 'vidis',
  WEB_SEARCH_BRAVE_PROVIDER: 'web_search_brave_provider',
  WORKSHEET_AI_WIZARD_THREE_STEP: 'worksheet_ai_wizard_three_step',
} as const;
